import Cookies from 'universal-cookie';

const cookies = new Cookies();

export const setTokenInCookie = (token) => {
    const expires = new Date();
    expires.setDate(expires.getDate() + 2); // Set the cookie to expire in 7 days
    cookies.set('isLoggedIn', { token: token }, { path: '/', expires: expires });
};
export const clearTokenInCookie = () => {
    cookies.remove('isLoggedIn', { path: '/' });
};